module.exports = __webpack_public_path__ + "testimonials.5340d060677db247ee08.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/img/parallax/testimonials.jpg
// module id = ../../../../../src/img/parallax/testimonials.jpg
// module chunks = styles